export default __webpack_public_path__ + "static/media/cake.1977b6dc.webp";